<div class="content animation-fade-in">
    <div class="media">
        <img src="assets/icons/email-send.svg" alt="Email send">
    </div>

    <p>Thank you !</p>
</div>
